import { TextField } from "@mui/material"
import { Control, Controller, FieldValues, Path } from "react-hook-form"

type LabelFieldProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>
  name: Path<TFieldValues>
  label?: string
}

export const LabelField = <TFieldValues extends FieldValues>(
  props: LabelFieldProps<TFieldValues>,
) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      render={({ field, fieldState }) => (
        <TextField
          inputProps={{ style: { fontSize: 20, fontWeight: 700 } }} // font size of input text
          // InputLabelProps={{style: {fontSize: 20}}} // font size of input label
          size="small"
          label={props.label ?? "Name"}
          fullWidth
          helperText={fieldState.error?.message}
          error={Boolean(fieldState.error)}
          {...field}
        />
      )}
    />
  )
}
